export class Address {
    public address1: string;
    public address2: string;
    public address3: string;
    public address4: string;
    public city: string;
    public state: string;
    public postalCode: string;
    public country: string;
    constructor(obj?: {
       address1?: string;
       address2?: string;
       address3?: string;
       address4?: string;
       city?: string;
       state?: string;
       postalCode?: string;
       country?: string;
    }) {
        if (obj != null) {
            this.address1 = typeof obj.address1 === 'undefined' ? this.address1 : obj.address1;
            this.address2 = typeof obj.address2 === 'undefined' ? this.address2 : obj.address2;
            this.address3 = typeof obj.address3 === 'undefined' ? this.address3 : obj.address3;
            this.address4 = typeof obj.address4 === 'undefined' ? this.address4 : obj.address4;
            this.city = typeof obj.city === 'undefined' ? this.city : obj.city;
            this.state = typeof obj.state === 'undefined' ? this.state : obj.state;
            this.postalCode = typeof obj.postalCode === 'undefined' ? this.postalCode : obj.postalCode;
            this.country = typeof obj.country === 'undefined' ? this.country : obj.country;
        }
    }
}
